//
// HCL Technologies Confidential
// (C) Copyright HCL Technologies 2025. All Rights Reserved.
// The source code for this program is not published or otherwise divested
// of its trade secrets, irrespective of what has been deposited with the
// U.S. Copyright Office.
//

/** @jsxImportSource @emotion/react */

// NOTE: This file uses Emotion CSS and should be migrated to Tailwind CSS.
// Dark mode colors reference Carbon design tokens defined in tailwind.config.js:
// - #161616 (carbon.dark)
// - #262626 (carbon.darkPanel)

export const commonStyles = {
  fullScreenCenter: {
    textAlign: 'center',
  },
  fullScreenLogo: {
    height: '40vmin',
    pointerEvents: 'none' as const,
  },
  fullScreenHeader: {
    backgroundColor: 'white',
    minHeight: '100vh',
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'black',
  },
  firstBar: (darkMode = false) => ({
    height: '110px',
    width: '100%',
    background: darkMode
      ? 'linear-gradient(270deg, #161616 0%, #262626 100%)'
      : 'linear-gradient(270deg, #0167B1 0%, #348DCE 100%)',
    color: 'white',
    boxShadow: '0px 1px 4px 0px #0000000F',
    transition: 'background 0.3s ease',
  }),
  firstBarText: {
    fontFamily: 'Inter',
    fontSize: '20px',
    fontWeight: 700,
    lineHeight: '26px',
    marginLeft: '50px',
    paddingTop: '40px',
  },
  messageText: {
    fontFamily: 'Roboto',
    color: '#354958',
    fontWeight: 400,
    fontSize: '16px',
    marginLeft: '50px',
  },
  footerStyle: {
    height: '6vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#1D1D23',
    marginTop: '20px',
    color: 'white',
    fontFamily: 'Inter',
    fontSize: '22px',
    fontWeight: 500,
    lineHeight: '2.4vw',
    bottom: 0,
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    overflowX: 'hidden' as const,
    backgroundColor: '#F9F9F9',
  },
  noAccessContainer: {
    marginTop: '300px',
    width: '558px',
    height: 'auto',
    top: '15vh',
    gap: '16px',
    position: 'absolute' as const,
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
  noAccessPage: {
    height: '100vh',
    width: '100vw',
  },
  warningIcon: {
    paddingLeft: '21px',
  },
  noAccessAdmin: {
    color: '#737373',
    fontFamily: 'Inter',
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '28px',
  },
  noAccessTextRole: {
    color: '#0066B0',
    fontFamily: 'Inter',
    fontSize: '22px',
    fontWeight: 600,
    lineHeight: '28px',
  },
  cancelIconContainer: {
    justifyContent: 'flex-start',
  },
  cancelIcon: {
    cursor: 'pointer',
    paddingLeft: '21px',
  },
  loadingContainer: {
    backgroundColor: '#F5F5FA',
    height: '100vh',
  },
  loadingImageContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
  loadingImage: {
    marginTop: '100px',
  },
  loadingText: {
    marginTop: '30px',
    fontFamily: 'Inter',
    fontSize: '22px',
    fontWeight: 500,
    lineHeight: '26.63px',
    color: '#0066B0',
  },
  loadingSvgContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  welcomeSection: {
    flex: '0 0 60%',
    display: 'flex',
  },
  firstBarInner: {
    display: 'flex',
    width: '100%',
  },
  communicationSection: {
    display: 'flex',
    width: '100%',
    position: 'relative' as const,
  },
  communicationContainer: {
    flex: '0 0 60%',
    minWidth: '600px',
    overflow: 'hidden',
  },
  myCommunicationsContainer: {
    flex: '0 0 40%',
    marginTop: '-160px',
  },
  pageContainer: {
    paddingBottom: '125px',
    backgroundColor: '#F5F5FA',
  },
  filterContainer: {
    marginLeft: '5vh',
    marginBottom: '16px',
  },
  searchContainer: {
    marginLeft: '5vh',
    marginBottom: '40px',
  },
  button: {
    color: '#0066B0',
    marginLeft: '40px',
    backgroundColor: 'transparent',
    border: 'none',
    fontFamily: 'Inter',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '28px',
  },
  button1: (darkMode = false) => ({
    color: darkMode ? '#78A9FF' : '#0066B0',
    marginLeft: '50px',
    marginRight: '10px',
    fontFamily: 'Inter',
    fontWeight: 400,
    fontStyle: 'normal',
    fontSize: '12px',
    lineHeight: '24px',
    letterSpacing: '0%',
    cursor: 'pointer',
    background: 'none',
    padding: '0 8px',
    textDecoration: 'none',
    border: 'none',
  }),
  navigatorContainer: (darkMode = false) => ({
    display: 'flex',
    height: '50px',
    backgroundColor: darkMode ? '#262626' : '#FFFFFF',
    width: '110%',
    marginLeft: '-8px',
    transition: 'background-color 0.3s ease',
  }),
  buttonText: {
    fontFamily: 'Inter',
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '28px',
    color: '#1D1D23',
    backgroundColor: 'transparent',
  },
  Filters: {
    backgroundColor: 'transparent',
    color: '#33333D',
    fontFamily: 'Inter',
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '14.52px',
    borderRadius: '4px',
    border: 'none',
    padding: '6px 15px',
    margin: '10px 0',
  },
  selectedFilter: {
    color: '#0550DC',
    fontFamily: 'Inter',
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: '14.52px',
    backgroundColor: 'transparent',
    borderRadius: '4px',
    border: 'none',
    padding: '6px 15px',
    margin: '10px 0',
  },
};
